import api from './APIInterceptor'

export default class MarketplaceService {
  static showOffers() {
    return api.get('/marketplace/offers')
  }

  static showOffer(id) {
    return api.get(`/marketplace/offers/${id}`)
  }
  static recordOfferTrackingEvent(offerId, eventData) {
    return api.post(`/marketplace/offers/${offerId}/track`, eventData)
  }
}
